export default class SensorIssueData {
  constructor(
    id,
    vesselId,
    registeredDate,
    checkValue,
    checkLimit,
    checkName,
    faultType,
    sensorName,
    isPersistent,
    numberOfDays = null
  ) {
    this.id = id;
    this.vesselId = vesselId;
    this.registeredDate = registeredDate;
    this.checkValue = checkValue;
    this.checkLimit = checkLimit;
    this.checkName = checkName;
    this.faultType = faultType;
    this.sensorName = sensorName;
    this.isPersistent = isPersistent;
    this.numberOfDays = numberOfDays;
  }

  get registeredDateString() {
    return this.registeredDate.toLocaleDateString("en-GB");
  }

  get registeredTimeString() {
    return this.registeredDate.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
  }

  get percentageLimitDeviation() {
    return ((this.checkValue - this.checkLimit) / this.checkLimit) * 100;
  }

}
